// Single source of truth for unwrapping API errors — the backend puts its
// business-rule text in response.data.message, which axios' generic Error message hides.
export function extractErrorMessage(error: unknown, fallback = 'Unknown error'): string {
  if (typeof error === 'object' && error !== null && 'response' in error) {
    const response = (error as { response?: { data?: { message?: string } } }).response;
    if (response?.data?.message) return response.data.message;
  }
  return error instanceof Error ? error.message : fallback;
}

// null for a network error, which has no response.
export function errorStatus(error: unknown): number | null {
  if (typeof error !== 'object' || error === null || !('response' in error)) return null;
  return (error as { response?: { status?: number } }).response?.status ?? null;
}
